var exports = {
  "i": "AltTextBadge.module__wrapper___ZXRfS1",
  "x": "AltTextBadge.module__button___ZXRfS1",
};

module.exports = exports;
